import { useState, useEffect } from 'react';
import { DesktopHeader } from './DesktopHeader';
import { TabletHeader } from './TabletHeader';
import { MobileHeader } from './MobileHeader';
import MobileMenu from '@components/MobileMenu';

const navigationLinks = [
  { path: '/services', label: 'Services', id: 'services' },
  { path: '/projects', label: 'Projects', id: 'projects' },
  { path: '/service-area', label: 'Service Area', id: 'service-area' },
  { path: '/about', label: 'About', id: 'about' },
  { path: '/contact', label: 'Contact', id: 'contact' }
];

export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setIsScrolled(window.scrollY > 50);
        ticking = false;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`site-nav fixed w-full z-[50] px-4 sm:px-6 lg:px-8 border-b ${
          isScrolled
            ? 'site-nav--scrolled border-white/10 shadow-lg'
            : 'bg-transparent border-transparent'
        }`}
      >
        <DesktopHeader isScrolled={isScrolled} navigationLinks={navigationLinks} />
        <TabletHeader
          isScrolled={isScrolled}
          navigationLinks={navigationLinks}
          onMenuOpen={() => setIsMobileMenuOpen(true)}
        />
        <MobileHeader isScrolled={isScrolled} onMenuOpen={() => setIsMobileMenuOpen(true)} />
      </nav>

      <MobileMenu
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
        links={navigationLinks}
      />
    </>
  );
}
